import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { Translate, ICrudGetAction, ICrudDeleteAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IWechatUser2 } from 'app/shared/model/wechat-user-2.model';
import { IRootState } from 'app/shared/reducers';
import { getEntity, deleteEntity } from './wechat-user-2.reducer';

export interface IWechatUser2DeleteDialogProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const WechatUser2DeleteDialog = (props: IWechatUser2DeleteDialogProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const handleClose = () => {
    props.history.push('/wechat-user-2');
  };

  useEffect(() => {
    if (props.updateSuccess) {
      handleClose();
    }
  }, [props.updateSuccess]);

  const confirmDelete = () => {
    props.deleteEntity(props.wechatUser2Entity.id);
  };

  const { wechatUser2Entity } = props;
  return (
    <Modal isOpen toggle={handleClose}>
      <ModalHeader toggle={handleClose}>
        <Translate contentKey="entity.delete.title">Confirm delete operation</Translate>
      </ModalHeader>
      <ModalBody id="examsysApp.wechatUser2.delete.question">
        <Translate contentKey="examsysApp.wechatUser2.delete.question" interpolate={{ id: wechatUser2Entity.id }}>
          Are you sure you want to delete this WechatUser2?
        </Translate>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={handleClose}>
          <FontAwesomeIcon icon="ban" />
          &nbsp;
          <Translate contentKey="entity.action.cancel">Cancel</Translate>
        </Button>
        <Button id="jhi-confirm-delete-wechatUser2" color="danger" onClick={confirmDelete}>
          <FontAwesomeIcon icon="trash" />
          &nbsp;
          <Translate contentKey="entity.action.delete">Delete</Translate>
        </Button>
      </ModalFooter>
    </Modal>
  );
};

const mapStateToProps = ({ wechatUser2 }: IRootState) => ({
  wechatUser2Entity: wechatUser2.entity,
  updateSuccess: wechatUser2.updateSuccess,
});

const mapDispatchToProps = { getEntity, deleteEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(WechatUser2DeleteDialog);
